import { BCMSRecord, Link, useBCMSContext, useStateManager, useWorkflow } from "@bcm-dev/bcms-vite";
import { PageContainer } from 'components/shared';
import Classes from "model";
import React from 'react';
import { SVGAsset } from 'res';
import "./styles.css";

/**
 * @function CheckImageGuidelinesPage
 * @return {React.Component}
 * @exported true
 * @description description
 */

export default function CheckImageGuidelinesPage(props) {
  const { goStep, nextStep } = useWorkflow() ?? {};
  const context = useBCMSContext();
  BCMSRecord.globalControllerFor(Classes, context);

  const data = { ...getDefaultPageData(), ...props.data ?? {} };
  const ui = { ...getDefaultPageUI(), ...props.ui ?? {} };

  const state = { data, ui };
  const controller = (state, setState) => ({
      data: state.data,
      ui: state.ui,

      onCancelClick: evt => goStep(0),

      onContinueClick: evt => goStep(4)
  });

  return(
    <PageContainer className="check-image-guidelines-page" state={ state } controller={ controller }>
      <PageContent/>
    </PageContainer>
  );
}

export const getDefaultPageData = () => ({
  
});
export const getDefaultPageUI = () => ({
  
});

function PageContent() {
  const { onCancelClick, onContinueClick } = useStateManager();
  
  return (
    <div className="check-image-page-content flex-container flex-vertical">
    <div className="upper-container flex-container flex-vertical justify-center flex-height">
        <div className="flex-container flex-horizontal align-center guideline-container">
          <SVGAsset id="RightArrowIcon" className="arrow-icon set-width inline-text-icon left-icon" />
          <p>Center the check on a dark surface, provide ample light. Align check.</p>
        </div>
        <div className="flex-container flex-horizontal align-center guideline-container">
          <SVGAsset id="RightArrowIcon" className="arrow-icon set-width inline-text-icon left-icon" />
          <p>We will take the photo for you.</p>
        </div>
      </div>
      
      <div className="check-image-footer flex-container flex-horizontal align-center set-width">
        <Link className="flex-width cancel-link clickable text-center" onClick={ onCancelClick }>Cancel Capture</Link>
        <Link className="flex-width continue-link clickable text-center" onClick={ onContinueClick }>Continue</Link>
      </div>
    </div>
  );
}